import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@env/environment';

import { AdaptiveScreenService } from './shared/services/adaptive-screen.service';
import { Store } from '@ngrx/store';
import { appActions } from './shared/state/actions';

import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare var fbq: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'xross-over-app';

  constructor(
    private router: Router,
    public adaptiveScreenService: AdaptiveScreenService,
    private store: Store,
    private http: HttpClient
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      fbq('track', 'PageView');
    });
  }

  ngOnInit() {
    this.store.dispatch(appActions.getTestimonials());
    this.store.dispatch(appActions.getBlogEntries());
    this.loadCloudFrontCookies();
    setInterval(() => {
      this.loadCloudFrontCookies();
    }, 240000);
  }

  private loadCloudFrontCookies(): void {
    this.http.get(environment.apiUrl + '/cloudfront/cookies', {
      withCredentials: true
    }).subscribe({
      next: (response) => {
        console.log('CloudFront cookies loaded', response);
      },
      error: (error) => {
        console.error('Error loading CloudFront cookies', error);
      }
    });
  }
}
